/* global common */
import {
  getCookie, isStage, sendGoogleEvent, sendRequest, setCookie,
} from '@html/_common/utils';

import AOScoutNewsletterSignupForm
  from '@scout/components/newsletter-signup-form/newsletter-signup-form';

export default function EmailAquisitionPopUp() {
  const DIALOG_SELECTOR = '.js-ao-email-aquisition-popup';
  const CLOSE_BUTTON_SELECTOR = '.js-ao-email-aquisition-popup__close';
  const CLOSE_CTA_SELECTOR = '.js-ao-email-aquisition-popup__close-cta';
  const HIDDEN_CLASS = 'hid';
  const COOKIE_NAME = 'hide_email_aquisition_popup';
  const newsletterType = 'SERP_popup';
  const ampEventType = 'email_popup';
  const OPENING_DELAY = 5000;
  const CLOSING_DELAY = 5000;
  const isMobileOrTablet = $(window).width() <= 1023;
  let dialogElement = null;
  let closeCtaButtonElement = null;
  let closingTimeout = null;
  const disableEmailAcquisitionPopup = true;

  this.common = undefined;
  if (typeof sendGoogleEvent !== 'undefined') {
    this.common = {
      func: { getCookie, setCookie },
      sendGoogleEvent,
      isStage,
      sendRequest,
      setCookie,
    };
  } else {
    this.common = common;
  }

  this.initiate = () => {
    if (disableEmailAcquisitionPopup) return;

    const canShowDialog = $('body').attr('data-show-email-popup');
    const { location } = window;

    if (!canShowDialog) return;

    const shouldHideDialog = this.common.func.getCookie(COOKIE_NAME);
    if (shouldHideDialog) return;

    // Hide on non-desktop devices
    if (isMobileOrTablet) return;

    // exclude b2b on staging
    const partnerId = window.trConfig?.customization?.partner_id;
    if (partnerId) {
      return;
    }

    // widgets
    if (location.href.includes('embed=')) {
      return;
    }

    /* exclude whitelabel, agent pages  */
    if (!this.common.isStage() && window.trConfig.customization) {
      return;
    }

    const urlPath = window.location.pathname;
    const urlQueryParams = window.location.search;
    const urlHash = window.location.hash;
    const stringToExclude = 'sign_up_form';
    const pathsToExclude = ['/mlp', '/awareness'];

    if (
      urlPath.includes(stringToExclude)
      || urlQueryParams.includes(stringToExclude)
      || urlHash.includes(stringToExclude)
      || pathsToExclude.some((excludedPath) => urlPath.includes(excludedPath))
    ) return;

    const isInIframe = window.location.href !== window.parent.location.href;
    if (isInIframe) return;

    setTimeout(() => {
      this.fetchPopup();
    }, OPENING_DELAY);
  };

  this.initiateListeners = () => {
    this.attachEventListeners();

    const newsletterSignupForm = new AOScoutNewsletterSignupForm('.js-ao-email-aquisition-popup__form-wrapper', newsletterType, ampEventType, this.onEmailSignupSuccess, this.onEmailSignupCancel);
    newsletterSignupForm.initiate();
  };

  this.attachEventListeners = () => {
    $('body').on('click', CLOSE_BUTTON_SELECTOR, () => {
      this.onEmailSignupCancel('x');
    });

    $('body').on('click', CLOSE_CTA_SELECTOR, () => {
      this.hidePopup('ok_got_it', false);
    });
  };

  this.showDialog = () => {
    // Check for support for older browsers
    if (typeof HTMLDialogElement !== 'function') {
      dialogElement.setAttribute('open', '');
      return;
    }

    dialogElement.show();

    this.common.sendGoogleEvent(
      'SERP',
      'Impression',
      'Newsletter Popup',
      {
        nonInteraction: true,
        popup_name: 'Newsletter Popup',
        ampEventName: 'popup_impression',
      },
    );
  };

  this.fetchPopup = () => {
    if (dialogElement?.length) {
      this.showDialog();

      return;
    }

    this.common.sendRequest('/api/popup/newsletter', {}, (response) => {
      if (!response.success) {
        this.common.sendGoogleEvent('Error', 'Newsletter Popup', 'No response');
      }

      $('main').append(response.template);
      closeCtaButtonElement = document.querySelector(CLOSE_CTA_SELECTOR);
      dialogElement = document.querySelector(DIALOG_SELECTOR);
      this.initiateListeners();
      this.checkIfCookieBannerIsVisible();
    }, { type: 'GET' });
  };

  this.checkIfCookieBannerIsVisible = () => {
    const checkInterval = setInterval(() => {
      if (dialogElement) {
        const cookiePopupId = dialogElement.dataset.cookieId;
        const isCookiePopupExist = !!document.getElementById(cookiePopupId);

        if (!isCookiePopupExist) {
          this.showDialog();
          clearInterval(checkInterval);
        }
      }
    }, 1000);
  };

  this.hidePopup = (eventType = 'no_thanks', setCookieParam = true) => {
    dialogElement.close();
    if (setCookieParam) this.setDialogCookie();
    if (closingTimeout) clearTimeout(closingTimeout);

    if (!eventType) return;
    this.common.sendGoogleEvent(
      'SERP',
      'Close Popup',
      eventType,
      {
        popupClosedElement: eventType,
        ampEventName: 'popup_closed',
      },
    );
  };

  this.initiateClosingTimeout = () => {
    if (closingTimeout) clearTimeout(closingTimeout);
    closingTimeout = setTimeout(() => {
      this.hidePopup('timeout', false);
    }, CLOSING_DELAY);
  };

  this.onEmailSignupSuccess = () => {
    closeCtaButtonElement.classList.remove(HIDDEN_CLASS);
    this.setDialogCookie();
    this.initiateClosingTimeout();
  };

  this.onEmailSignupCancel = (eventType = 'no_thanks') => {
    this.setDialogCookie();
    this.hidePopup(eventType);
  };

  this.setDialogCookie = () => {
    this.common.func.setCookie({ name: COOKIE_NAME, value: true, path: '/' });
  };
}
